import React from "react";

const TotalBalanceBlue = ({ width }) => (
  <svg
    width={width || "14"}
    height={width || "14"}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="7" fill="#387CFF" />
  </svg>
);

export default TotalBalanceBlue;
